const lang = {
	PROFILE: "Profile",
	LOG_OUT: "Logout",
	PLEASE_WAIT: "Please Wait",
	OK: "Ok",
	APPLY: "Apply",
	NEXT: "Next",
	BACK: "Back",
	SAVE: "Save",
	SAVE_AND_NEXT: "Save and Next",
	DELETE: "Delete",
	UPLOAD: "Upload",
	UPLOAD_CONTENT: "Upload Content",
	UPLOAD_IMAGE: "Upload Image",
	UPLOAD_CSV: "Upload Csv",
	UPLOADED_IMAGE: "Uploaded Image",
	UPLOADED_CSV: "Uploaded Csv",
	DRAG_TEXT: "Drag file to this area or ",
	BROWSE: "browse",
	EDIT: "Edit",
	CANCEL: "Cancel",
	CONTINUE: "Continue",
	CLEAR_ALL: "Clear All",
	UPLOAD_FILE: "Uploaded File:",
	OPEN_EDITOR: "Open Editor",
	DOWNLOAD: "Download",
	UPLOAD_NEW: "Upload New",
	OR: "OR",
	PREVIEW: "Preview",
	SUBMIT: "Submit",
	RESET: "Reset",
	LEAVE_ANYWAY: "Leave Anyway",
	DUPLICATE: "DUPLICATE",
	CANCEL_CAPS: "CANCEL",
	DONE: "Done",
	CLOSE: "Close",
	EDIT_CAPS: "EDIT",
	CONTENT_COPIED: "Content Copied Successfully",
	COPY: "Copy",
};

export default lang;
